export type AnnotationColor = 'blue' | 'green' | 'yellow' | 'red' | 'orange';
const AnnotationColorHex = [
  {
    color: 'blue',
    hex: '#4353ff',
  },
  {
    color: 'green',
    hex: '#12d090',
  },
  {
    color: 'orange',
    hex: 'yellow',
  },
  {
    color: 'yellow',
    hex: '#ffd448',
  },
  {
    color: 'red',
    hex: '#fb4f4f',
  },
];

export const AnnotationColorToHex = (color: string) => {
  return AnnotationColorHex.find(c => c.color === color)?.hex;
};
export const AnnotationHexToColor = (hex: string) => {
  return AnnotationColorHex.find(c => c.hex === hex)?.color;
};
